import Body from "./Body";
import TimeFilter from "./TimeFilter";
import ShowInfo from './ShowInfo';

export const Components = {
  Body,
  TimeFilter,
  ShowInfo,
};
